<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LoadingProgress',
  computed: {
    ...mapGetters({
      contentsLoading: 'ui/contentsLoading',
    }),
  },
  watch: {
    contentsLoading: {
      handler(val) {
        if (val) {
          this.$loading({
            lock: true,
            text: this.$t('처리중 입니다...'),
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
        } else {
          this.$loading().close()
        }
      },
    },
  },
}
</script>
